<template>
  <v-container>
    <v-col>
      <h5>{{$t('Gsm settings')}}</h5>
      <v-col>
      <v-text-field
       dense
       outlined  
       label="APN"
       v-model="value.apn"
       @input="update('type', $event.target.value)"
      ></v-text-field>
      </v-col>
      <v-col>
      <v-text-field
       dense
       outlined  
       label="Number"
       v-model="value.number"
       @input="update('type', $event.target.value)"
      ></v-text-field>
      </v-col>
      <v-col>
      <v-text-field 
       label="PIN"
       dense 
       outlined
       v-model="value.psk"
       :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
       @click:append="show = !show"
       counter
       :hint="$t('At least 8 characters')"
       :rules="rules"
       :type="show ? 'text' : 'password'"
       @input="update('type', $event.target.value)"
      ></v-text-field>
      </v-col>
    </v-col>
  
  </v-container>
</template>
<script>
export default {

  name: 'GsmConfig',
  props: ['value'],
  data() {
    return {
      show: false,
      psk: '',
      rules: [
       value => !!value || this.$t('Required'),
       v => v.length >= 8 || this.$t('Min 8 characters'),
      ],

    }
  },
  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    

  },

}
</script>